import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-vendor",
  "use": "icon-soc-l1-mall-vendor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-vendor\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 576h640v192H192V576zm64-256h128v256H256V320zm192 0h128v256H448V320zm192 0h128v256H640V320z\" />\r\n  <path d=\"M288 224h64v64h-64V224zm192 0h64v64h-64V224zm192 0h64v64h-64V224z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-vendor.svg
// module id = 5V0R
// module chunks = 478